export default __webpack_public_path__ + "static/media/BinaryHeap.8cc118e6.jpg";